import { apiPath } from "./apiPath";
import type { AccountDataPayloadV1 } from "./accountDataTypes";

const jsonHeaders = { Accept: "application/json", "Content-Type": "application/json" };

export async function fetchAccountData(): Promise<AccountDataPayloadV1 | null> {
  const r = await fetch(apiPath("/api/account-data"), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (r.status === 401) return null;
  if (!r.ok) throw new Error(`account-data get ${r.status}`);
  const data = (await r.json()) as { payload?: AccountDataPayloadV1 };
  return data.payload ?? null;
}

export async function patchAccountData(payload: AccountDataPayloadV1): Promise<AccountDataPayloadV1 | null> {
  const r = await fetch(apiPath("/api/account-data"), {
    method: "PATCH",
    credentials: "include",
    headers: jsonHeaders,
    body: JSON.stringify({ payload }),
  });
  if (r.status === 401) return null;
  if (!r.ok) throw new Error(`account-data patch ${r.status}`);
  const data = (await r.json()) as { payload?: AccountDataPayloadV1 };
  return data.payload ?? null;
}
